@if (baseElement.isVisible) {
  <div [ngClass]="wrapperClasses">
    @if (baseElement.label) {
      <div class="tw:w-full">
        <label
          [for]="dateInputId"
          [ngClass]="labelClasses"
          class="tw:flex tw:items-center tw:gap-0.5"
        >
          {{ baseElement.label }}
          @if (baseElement.required) {
            <span class="tw:text-required">*</span>
          }
          @if (baseElement.tooltip) {
            <div class="tw:flex tw:items-center tw:ml-0.5">
              <mat-icon
                matTooltip="{{ baseElement.tooltip }}"
                matTooltipPosition="above"
                class="tw:cursor-help tw:text-lg tw:h-4 tw:w-4 tw:overflow-visible tw:text-[rgba(0,0,0,0.54)] tw:hover:text-(--color-blue-main)"
              >
                help_outline
              </mat-icon>
            </div>
          }
        </label>
      </div>
    }
    <app-tooltip [tooltip]="tooltip" [disabled]="disableTooltip">
      <div class="tw:w-full tw:relative" #dateTimeOrigin>
        <mat-form-field
          appearance="outline"
          class="tw:w-full"
          [class.disabled]="baseElement.isDisabled || !baseElement.editMode"
          [class.readonly]="baseElement.isReadonly"
        >
          @if (timeOnly) {
            <input
              #dateInput
              matInput
              [ngClass]="inputClasses"
              [id]="dateInputId"
              [placeholder]="placeholder || ''"
              [value]="timeDisplayValue"
              [readonly]="true"
              [required]="baseElement.required"
              (click)="onInputClick()"
              (blur)="onBlur()"
              class="form-component tw:cursor-pointer"
            />
            @if (isDatepickerEnabled) {
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="omm-time-picker-toggle"
                (click)="openTimePicker(); $event.stopPropagation()"
                aria-label="Open time picker"
              >
                <mat-icon>schedule</mat-icon>
              </button>
            }
          } @else {
            <input
              #dateInput
              matInput
              [ngClass]="inputClasses"
              [id]="dateInputId"
              [matDatepicker]="picker"
              [placeholder]="placeholder || ''"
              [formControl]="dateControl"
              [readonly]="baseElement.isReadonly"
              [required]="baseElement.required"
              [min]="resolvedMinDate"
              [max]="resolvedMaxDate"
              (click)="onInputClick()"
              (dateInput)="onDateInput($event)"
              (dateChange)="onDateChange($event)"
              (blur)="onBlur()"
              class="form-component"
            />
            @if (isDatepickerEnabled) {
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              @if (showTime) {
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="omm-time-picker-toggle"
                  (click)="openTimePicker(); $event.stopPropagation()"
                  aria-label="Open time picker"
                >
                  <mat-icon>schedule</mat-icon>
                </button>
              }
            }
            <mat-datepicker
              #picker
              [calendarHeaderComponent]="customHeader"
              (opened)="onDatepickerOpened()"
              (closed)="onDatepickerClosed()"
            ></mat-datepicker>
          }
          <ng-content select="[suffix]"></ng-content>
        </mat-form-field>
      </div>
    </app-tooltip>
  </div>
}
